<script>
import { mapActions, mapState } from 'vuex';
import TwDomainSelectorModal from './TwDomainSelectorModal';

export default {
  name: 'TwDomainSelector',
  components: { TwDomainSelectorModal },
  props: {
    productTypeId: {
      type: Number,
      required: true,
    },
    selectedDomains: {
      type: Array,
      default: () => [],
    },
    selectedDomain: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      domains: state => state.app.domains.items,
    }),
    filteredAvailableDomains() {
      const domainIds = this.selectedDomains.map(selectedDomain => selectedDomain.domain.id) || [];
      return this.domains.filter(domain => domainIds.indexOf(domain.id) === -1);
    },
  },
  data() {
    return {
      toggled: false,
      search: '',
      headers: [
        { text: this.$t('domains.table.shortName'), value: 'shortName' },
        { text: this.$t('domains.table.name'), value: 'name' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'description',
      },
      available: [],
      selected: [],
    };
  },
  created() {
    this.getDomainsByProductTypeId(this.productTypeId);
  },
  methods: {
    ...mapActions({
      getDomainsByProductTypeId: 'app/getDomainsByProductTypeId',
    }),
    update(event) {
      this.$emit('update', event);
      this.toggled = false;
    },
    activate(event) {
      this.$emit('activate', {
        ...this.selectedDomain,
        active: event,
      });
    },
  },
};
</script>

<template>
  <div>
    <v-card class="text-lg-right">
      <v-flex shrink>
        <v-chip
          v-for="(selectedDomain, index) in selectedDomains"
          :key="`selected-domains__${index}`"
          :color="selectedDomain.active ? 'teal' : 'error'"
          text-color="white"
          class="tw-domain-selector__chip"
          @click="$emit('select', selectedDomain)"
        >
            <span>
              <strong>{{ selectedDomain.domain.shortName }}</strong>
            </span>
        </v-chip>

        <v-btn
          :disabled="!domains.length || !filteredAvailableDomains.length || loading"
          :loading="loading"
          color="primary"
          depressed
          @click="toggled = true"
        >
        <span v-if="!loading && filteredAvailableDomains.length">
          {{ $t('buttons.addDomain') }}
        </span>
          <span v-else>{{ $t('buttons.allDomainsAdded') }}</span>
        </v-btn>
        <tw-domain-selector-modal
          v-if="toggled"
          :available-domains="filteredAvailableDomains"
          :selected-domains="selectedDomains"
          :loading="loading"
          @update="update"
          @cancel="toggled = false"
        />
      </v-flex>
    </v-card>
    <div v-if="selectedDomain" class="tw-domain-selector__switch-wrapper">
      <v-flex class="tw-domain-selector__switch">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-switch
              :input-value="selectedDomain.active"
              :label="$t('inputs.misc.webActive')"
              :disabled="loading"
              :loading="loading"
              v-on="on"
              @change="activate"
            />
          </template>
          <span>
          {{ $t('inputs.tooltips.activeSwitch', { domain: selectedDomain.domain.name }) }}
        </span>
        </v-tooltip>
      </v-flex>
    </div>
  </div>
</template>

<style lang="scss">
  @import './../assets/scss/variables.scss';
  @import './../assets/scss/animations.scss';

  .tw-domain-selector__table-row {
    cursor: pointer;
  }

  .tw-domain-selector__no-content {
    color: $brand-grey-light;
    user-select: none;
  }

  .tw-domain-selector__switch-wrapper {
    overflow: hidden;
    text-align: right;
    padding: 0 $padding-md;
    animation: expandFade;
    animation-duration: $animation-duration-short;
  }

  .tw-domain-selector__switch {
    display: inline-block;
  }

  .v-chip__content {
    user-select: none;
    cursor: pointer!important;
  }

  .v-input {
    padding-top: 0;
  }

  .v-messages {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwDomainSelector.vue